/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RegistrationsControllerGetCompanyRolesQueryResponse } from "../../models/registrationsController/RegistrationsControllerGetCompanyRoles";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { registrationsControllerGetCompanyRoles } from "../../clients/registrationsService/registrationsControllerGetCompanyRoles";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const registrationsControllerGetCompanyRolesQueryKey = () => [{
  url: '/api/v1/registrations/company-roles'
}] as const;
export type RegistrationsControllerGetCompanyRolesQueryKey = ReturnType<typeof registrationsControllerGetCompanyRolesQueryKey>;
export function registrationsControllerGetCompanyRolesQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = registrationsControllerGetCompanyRolesQueryKey();
  return queryOptions<RegistrationsControllerGetCompanyRolesQueryResponse, ResponseErrorConfig<Error>, RegistrationsControllerGetCompanyRolesQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return registrationsControllerGetCompanyRoles(config);
    }
  });
}

/**
 * @description Returns the list of predefined company roles for the registration form dropdown.
 * @summary Get predefined company roles
 * {@link /api/v1/registrations/company-roles}
 */
export function useRegistrationsControllerGetCompanyRoles<TData = RegistrationsControllerGetCompanyRolesQueryResponse, TQueryData = RegistrationsControllerGetCompanyRolesQueryResponse, TQueryKey extends QueryKey = RegistrationsControllerGetCompanyRolesQueryKey>(options: {
  query?: Partial<QueryObserverOptions<RegistrationsControllerGetCompanyRolesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? registrationsControllerGetCompanyRolesQueryKey();
  const query = useQuery({
    ...registrationsControllerGetCompanyRolesQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}